import React, { useEffect } from 'react';
import styles from './conversationActivity.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConversations, invalidateConversationActivity } from 'actions/conversations';
import cx from 'classnames';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';

export default function ConversationActivity(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

  const shares = useSelector((state) => _.get(state, 'conversations.shares.items') || []);
  const recipientNames = useSelector((state) => _.get(state, 'selection.recipientNames') || []);

  useEffect(() => {
  }, [shares])


const handleBackClicked = () => {
    dispatch(invalidateConversationActivity());
    history.push('/paperflite-home');
}

const padNumber = (number = 0, pad) => {
  number = Math.ceil(number);

  const length = pad - String(number).length + 1;
  let padding = '';
  if (length > 0) {
    padding = Array(pad - String(number).length + 1).join('0');
  }
  return padding + number;
}

const timeSpentValue = (timeSpent) => {
  let timeSpentValue = `~${padNumber(timeSpent, 1)}s`;

  if (timeSpent >= 60) {
    timeSpentValue = `~${padNumber(Math.round(timeSpent / 60), 1)}m`;
  }

  return timeSpentValue;
}

const getShareDetails = () => {
    const shareItems = _.map(shares, (item) => (
      <div key={item.share.id} className={styles.shares}>
      <div className={styles.titleContent}>
        <span className={styles.shareTitle}>
          {item.share.subject}
        </span>
        <a href={`${webAppUrl}/conversations/${item.share.id}`} rel="noopener noreferrer" target="_blank">
          <div className={styles.openConversation}>
            <i className="paperflite-left-arrow" />
            <p>OPEN</p>
        </div>
        </a>
        </div>
        <span className={styles.sharedBy}>
          Shared by {item.createdBy.firstName}
        </span>
        <div className={styles.shareDetails}>
          <span className={styles.assetsCount}>
            {item.totalAssetsCount} Assets
          </span>
          <span className={styles.icons}>
            <span className={styles.timeSpent}>{timeSpentValue(item.share.totalTimeSpent)}</span>
            <i className={cx("paperflite-email-open", styles.icon, {
              [styles.activeIcon]: item.share.uniqueEmailOpens > 0
            })}></i>
            <i className={cx("paperflite-click-rate", styles.icon, {
              [styles.activeIcon]: item.share.uniqueLinkClicks > 0
            })}></i>
            <i className={cx("paperflite-timespent", styles.icon, {
              [styles.activeIcon]: item.share.totalTimeSpent > 0
            })}></i>
          </span>
        </div>
      </div>
    ));
    
    return(
        <div>
            {shareItems}
        </div>
    )
    }
  

  return (
  <div className={styles.conversationActivityContainer}>
    <div className={styles.header}>
      <p className={styles.headerContainer}>
        <span className={styles.backButton} onClick={() => handleBackClicked()}>
        <i className="paperflite-left-arrow"/>
        <span className={styles.back}>
          BACK
        </span>
        </span>
      </p>
    </div>
    <div className={styles.containerHeader}>
        <span>Conversation Activity</span>
    </div>
    <div className={styles.allShares}>
    {getShareDetails()}
    </div>
  </div>
  )
}